import StaffSidebar from "../../../components/sidebars/StaffSidebar"
import StaffProfileBox from "../../Staff/components/StaffProfileBox"
import StaffDisplayData from "../components/StaffDisplayData"
import {
  GET_STAFF_ID_BY_MEMBERSHIP_ID,
  GET_STAFF_PROFILE_BOX,
  GET_STAFF_PROFILE_TABLE,
} from "../queries"
import { useContext, useState, useEffect } from "react"
import { UserContext } from "../../../context/userContext"
import { useNavigate } from "react-router-dom"
import { useQuery } from "@apollo/client"
import { Button } from "primereact/button"

import styles from "../../../styles/StaffProfile.module.css"

export default function StaffProfile() {
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()
  const staff_membership_id = userCtx.current_staff_membership_id
  const [currentStaffIDStamp, setCurrentStaffIDStamp] = useState(null)
  const [canEditStaff, setCanEditStaff] = useState(false)
  const [userIsSupervisor, setUserIsSupervisor] = useState(false)
  const [staffDataDisplay, setStaffDataDisplay] = useState(null)
  const [loadingStaffDisplayData, setLoadingStaffDisplayData] = useState(false)

  const { data: staffData } = useQuery(GET_STAFF_ID_BY_MEMBERSHIP_ID, {
    variables: { staff_membership_id },
    skip: !staff_membership_id,
    fetchPolicy: "no-cache",
    onError: () => { console.error("Error fetching staff ID by membership ID") },
    onCompleted: (data) => {
      if (!data?.staffDataByStaffMembershipID) {
        console.warn("No staff data found for the given membership ID")
      }
    },
  })

  const { refetch: refetchUser } = useQuery(
    GET_STAFF_PROFILE_BOX,
    {
      variables: { organization_id: null, staff_id: null }, // Initially empty, refetch will update this
      skip: true, // Skip initial fetch, we will trigger refetch with variables later
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        if (!data?.getStaffProfileBox || data.getStaffProfileBox.length === 0) {
          return
        }

        setCurrentStaffIDStamp(data.getStaffProfileBox.staff_id_stamp)

        if (
          userCtx.session.user.staff_id ===
          data.getStaffProfileBox.staff_primary_supervisor
        ) {
          setUserIsSupervisor(true)
        }
      },
      onError: (error) => {
        console.error("Error fetching user data:", error)
      }
    }
  )

  const { refetch: refetchStaffProfile } = useQuery(
    GET_STAFF_PROFILE_TABLE,
    {
      variables: {
        staff_id: userCtx.session.user.staff_id,
        organization_id: userCtx.session.user.organization_id,
        enterprise_id: userCtx.session.user.enterprise_id,
        idTemplate: "staff",
        type: "system",
        participant_id: "",
        idStamp: null,
      },
      skip: true, // Skip initial fetch, we will trigger refetch with variables later
      fetchPolicy: "no-cache",
      onCompleted: (data) => {
        setStaffDataDisplay(data.template)
        setLoadingStaffDisplayData(false)
      },
      onError: (error) => {
        console.error("Error fetching staff profile data", error)
        setLoadingStaffDisplayData(false)
      },
    }
  )

  useEffect(() => {
    if (!staffData?.staffDataByStaffMembershipID) return

    const { organization_id, staff_id } = staffData.staffDataByStaffMembershipID

    // Fetch User Data
    if (organization_id && staff_id) {
      refetchUser({ organization_id, staff_id })
    }

    // Fetch Staff Profile Data
    if (currentStaffIDStamp) {
      setLoadingStaffDisplayData(true)
      refetchStaffProfile({
        staff_id: userCtx.session.user.staff_id,
        organization_id: userCtx.session.user.organization_id,
        enterprise_id: userCtx.session.user.enterprise_id,
        idTemplate: "staff",
        type: "system",
        participant_id: "",
        idStamp: currentStaffIDStamp,
      })
    }
  }, [
    currentStaffIDStamp,
    refetchStaffProfile,
    refetchUser,
    staffData,
    userCtx.session,
  ])

  useEffect(() => {
    if (
      userCtx.session.user.staff_role >= 0 &&
      userCtx.session.user.staff_role <= 4 &&
      userCtx.session.user.staff_role !== -1
    ) {
      setCanEditStaff(true)
    }
  }, [userCtx.session.user.staff_role, userIsSupervisor])

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <StaffSidebar />
      </div>

      <div className="main-content">
        <StaffProfileBox />

        <div className={styles.staffProfilePageContent}>
          <div className={styles.staffProfilePageHeader}>
            <Button
              label="Edit"
              className={styles.editButtonToggle}
              onClick={() =>
                navigate(`/organization/form/staff/1/${currentStaffIDStamp}`)
              }
              disabled={!canEditStaff}
            />
          </div>

          <StaffDisplayData
            loadingStaffData={loadingStaffDisplayData}
            staffData={staffDataDisplay}
            currentStaffIDStamp={currentStaffIDStamp}
          />
        </div>
      </div>
    </div>
  )
}
